const SERVER_URL = {
    DEVELOPMENT: "http://localhost:3001/api/kosirock_ceo",
    PRODUCTION: "https://api.kosirock.co.kr/api/kosirock_ceo"
};

const REG_EXP = {
    EMAIL: /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/,
    PASSWORD: /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{8,16}$/,
    PHONE: /^(01[0-9]{1}-?\d{3,4}-?\d{4})$|^(0[2-9]{1}\d{0,1}-?\d{3,4}-?\d{4})$/,
    NUMBER: /[^0-9]/g
};

const INFORMATION = {
    EMAIL: "dev@huesik.co.kr",
};

const NOTIFICATION_STATUS = {
    welcome: {
        btn_text: "🎉",
        btn_color: "badge-secondary-lighten",
        bg_color: "bg-secondary"
    },
    inquiry_register: {
        btn_text: "문의사항 보기",
        btn_color: "badge-primary-lighten",
        bg_color: "bg-primary"
    },
    kosiwon_register: {
        btn_text: "등록 요청",
        btn_color: "badge-primary-lighten",
        bg_color: "bg-primary"
    },
    kosiwon_register_approved: {
        btn_text: "신규 등록 완료",
        btn_color: "badge-success-lighten",
        bg_color: "bg-success"
    },
    kosiwon_edit: {
        btn_text: "수정 요청 확인",
        btn_color: "badge-warning-lighten",
        bg_color: "bg-warning"
    },
    kosiwon_edit_approved: {
        btn_text: "정보 수정 완료",
        btn_color: "badge-info-lighten",
        bg_color: "bg-info"
    },
    kosiwon_rejected: {
        btn_text: "거절 사유 확인",
        btn_color: "badge-danger-lighten",
        bg_color: "bg-danger"
    },
    notice_register: {
        btn_text: "공지사항 확인",
        btn_color: "badge-secondary-lighten",
        bg_color: "bg-secondary"
    },
    // event: {
    //     btn_text: "이벤트 확인",
    //     btn_color: "badge-secondary-lighten",
    //     bg_color: "bg-secondary"
    // },
    default: {
        btn_text: "⚠️",
        btn_color: "badge-warning-lighten",
        bg_color: "bg-warning"
    }
}

export {
    SERVER_URL,
    REG_EXP,
    INFORMATION,
    NOTIFICATION_STATUS
};